module.exports = __webpack_public_path__ + "img/PlayNext.30a29880.svg";